<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />

        <!-- style="position: relative; for col-md-3" margin-left: 10px; position-fixed -->
        <div class="row ">
          
          <div class="col-md-3 col-12 d-flex flex-column align-items-center position-relative responsive-profile"  >
            <div class=" text-center image-edit-container"  style="position: absolute; z-index: 900;">
               <!-- Hidden file input -->
              <input type="file" id="uploadKTP" ref="foto_ktp" @change="handleUpload" style="display: none" accept="image/*"/>

              <!-- Clickable image label -->

              <img :src="currentEmployee.foto_ktp" class="rounded-circle img-fluid " alt="Profile Photo" 
              style="width: 210px; height: 210px; object-fit: cover; border: 10px solid #F9B233; " @click="triggerUpload">

              <i class='edit-icon bx bxs-pencil'></i>
            </div>
            <div class="card text-white px-3  text-center" style="background-color: #00B680; width: 210px; height: 420px; margin-top: 95px; padding-top: 8rem; position: relative; z-index: 1;">
              <h5 class="fw-bold mb-1 text-white">{{ currentEmployee.nama }}</h5>
              <p v-if="currentEmployee.nama_departemen" class="mb-1 fw-semibold">
                {{ currentEmployee.nama_departemen }}
              </p>
              <p v-if="currentEmployee.nama_jabatan" class="mb-4">
                {{ currentEmployee.nama_jabatan }}
              </p>
              <p v-if="calculateAge(currentEmployee.dob)" class="fw-bold mb-0">
                {{ calculateAge(currentEmployee.dob) }}
              </p>
              <p v-if="currentEmployee.dob" class="mb-0">
                {{ currentEmployee.place_dob ? currentEmployee.place_dob + ', ' : '' }}{{ formatDate(currentEmployee.dob) }}
              </p>
              <p v-if="currentEmployee.telepon" class="mb-4">{{ currentEmployee.telepon }}</p>

              <!-- kasih v-if klo g null dia muncul   -->
              <div class="" v-if="currentEmployee.terminate_date !== NULL || currentEmployee.terminate_date !== '' ">

                <span class="badge bg-danger" >{{ currentEmployee.terminate_date }}</span> <br/>
                <span class="badge bg-danger">{{  currentEmployee.terminate_reason }}</span>
              </div>

            </div>
          </div>

          <div class="col-md-9 col-12 responsive-detail">

            <div class="menu-tab" >
              <div class="d-flex justify-content-start align-items-center gap-4 order-2 order-md-1 mt-4 mt-md-0">
                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2" @click="activePage('general_info'); "
                    :class="{ 'menu-top': active_page === 'general_info', 'text-muted': active_page !== 'general_info' }" style="cursor: pointer;">
                    General
                </div>

                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2" @click="activePage('employement_data');"
                    :class="{ 'menu-top': active_page === 'employement_data', 'text-muted': active_page !== 'employement_data' }" style="cursor: pointer;">
                    Data
                </div>

                
                <div v-if="!isEditing" v-show="tipe_user === 'OWNER'" class="font-weight-normal text-md position-relative  px-4 py-2" @click="activePage('salary');"
                    :class="{ 'menu-top': active_page === 'salary', 'text-muted': active_page !== 'salary' }" style="cursor: pointer;">
                    Salary
                </div>
                
                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2" @click="activePage('tax_config');"
                    :class="{ 'menu-top': active_page === 'tax_config', 'text-muted': active_page !== 'tax_config' }" style="cursor: pointer;">
                    Tax 
                </div>
                
                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2 " @click="activePage('bpjs_config');"
                  :class="{ 'menu-top': active_page === 'bpjs_config', 'text-muted': active_page !== 'bpjs_config' }" style="cursor: pointer;">
                  BPJS 
                </div>

                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2 " @click="activePage('history');"
                  :class="{ 'menu-top': active_page === 'history', 'text-muted': active_page !== 'history' }" style="cursor: pointer;">
                  History
                </div>
                
                  
                  
              </div>

            </div>

            <!-- /add -->
            <form @submit.prevent="update">
               
              <div class="card">
                <div class="card-body" >
                
                  <div class="row" :class="{ 'custom-active': active_page !== 'general_info' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'general_info'">
                      <div class="row ">
                        <div class="col-md-6 ">
                          <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">Basic Info</h5>
                          </div>
                          <div class="">
                    

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" style="font-weight: 300;">Full Name <span class="text-danger">*</span></label>
                              <input type="text" v-model="currentEmployee.nama"  class="form-control" placeholder="" :disabled="isReadOnly" required>
                              
                              
                            </div>
                            
                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >No.Whatsapp <span class="text-danger">*</span></label>
                              <vue-tel-input :value="currentEmployee.telepon" input-class="form-control" mode="international" :disabled="currentEmployee && currentEmployee.terminate_date !== ''" :auto-format="true" @input="onPhoneChange" />
                              <!-- <input type="text" v-model="currentEmployee.telepon" class="form-control" placeholder="" required> -->
                              
                            </div>

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >Email</label>
                              <input type="text" v-model="currentEmployee.email" class="form-control" :disabled="isReadOnly" placeholder="" >
                              
                              
                            </div>
                            
                            
                            <div class="d-flex align-items-center mb-2 form-group">
                              <!-- <div class="form-group"></div> -->
                              <label for="" class="col-3" >Birthdate <span class="text-danger">*</span></label>
                              <div class="input-groupicon w-100" style="z-index: 100;">
                                <datepicker v-model="currentEmployee.dob" class="picker" :editable="true" :clearable="false"
                                  required />
                                <a class="addonset">
                                  <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                                </a>
                              </div>
                              
                            </div>

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >Place Of Birth <span class="text-danger">*</span></label>
                              <input type="text" v-model="currentEmployee.place_dob" class="form-control" placeholder="" :disabled="isReadOnly" required>
                              
                            </div>

                            <div class="d-flex align-items-center mb-3 form-group">
                              <label for="" class="col-3" >Gender</label>
                              <vue-select :options="GenderList" v-model="currentEmployee.jenis_kelamin" placeholder="Pilih Jenis Kelamin" :disabled="isReadOnly" class="w-100"/>

                            </div>
                            <div class="d-flex align-items-center mb-3">
                              <label for="" class="col-3" >Marital Status</label>
                              <vue-select
                                :options="maritalStatusList"
                                v-model="currentEmployee.marital_status"
                                placeholder="Pilih Status Perkawinan"
                                :disabled="isReadOnly"
                                class="w-100">
                              </vue-select>
                              <!-- <input type="text" class="form-control" v-model="currentEmployee.marital_status" placeholder=""> -->
                              
                              
                            </div>
                            <div class="d-flex align-items-center mb-3">
                              <label for="" class="col-3" >Blood Type</label>
                              <vue-select
                                :options="bloodTypeList"
                                v-model="currentEmployee.golongan_darah"
                                placeholder="Pilih Golongan Darah"
                                :disabled="isReadOnly"
                                class="w-100">
                              </vue-select>
                              <!-- <input type="text" class="form-control" v-model="currentEmployee.golongan_darah" placeholder=""> -->
                              
                              
                            </div>
                            <div class="d-flex align-items-center mb-3">
                              <label for="" class="col-3" >Religion</label>
                              <vue-select :options="ReligionList" class="w-100" v-model="currentEmployee.agama" :disabled="isReadOnly" placeholder="None" />
                              
                              
                            </div>

                            <div class="d-flex align-items-center mb-3">
                              <label for="" class="col-3" >Mother's Name</label>
                              <input type="text" class="form-control" v-model="currentEmployee.nama_ibu_kandung" :disabled="isReadOnly" placeholder="">
                              
                              
                            </div>

                          </div>

                        </div>


                        <div class="col-md-6">
                          <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">Identity & Address</h5>
                          </div>

                          <div class="">

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >NIK (KTP/Identitas)</label>
                              <input type="text" class="form-control" v-model="currentEmployee.no_ktp" :disabled="isReadOnly" placeholder="" />
                            </div>

                            <!-- <div class="d-flex align-items-center mb-3">
                              <label for="" class="col-3" >Postal Code</label>
                              <input type="text" v-model="currentEmployee.kode_pos" class="form-control" placeholder="" >
                              
                              
                            </div> -->

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >Citizen ID Address</label>
                              <textarea class="form-control" v-model="currentEmployee.alamat" :disabled="isReadOnly"></textarea>
                              
                            </div>

                            
                            

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >Residential ID Address</label>
                              <textarea class="form-control" v-model="currentEmployee.alamat2" :disabled="isReadOnly"></textarea>
                              
                            </div>

                            <div class="title-tab py-2 mb-3">
                              <h5 class=fw-bold>Emergency Contact</h5>
                            </div>
                            
                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >No. Whatsapp</label>
                              <vue-tel-input :value="currentEmployee.kontak_darurat" :disabled="currentEmployee && currentEmployee.terminate_date !== ''" input-class="form-control" mode="international" :auto-format="true" @input="onPhoneEmergencyChange" />
                              
                              <!-- <input type="text" v-model="currentEmployee.kontak_darurat" class="form-control" placeholder=""> -->
                              
                            </div>

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >Name Emergency Contact</label>
                              <input type="text" v-model="currentEmployee.nama_kontak_darurat" class="form-control" :disabled="isReadOnly" placeholder="">
                              
                            </div>

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >Status</label>
                              <input type="text" v-model="currentEmployee.hubungan_kontak_darurat" :disabled="isReadOnly" class="form-control" placeholder="">
                              
                            </div>

                            
                            
                            
                            
                            
                            
                          </div>

                        </div>
                      </div>
                      
                    </div>
                  </div>

                  <div class="row" :class="{ 'custom-active': active_page !== 'employement_data' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'employement_data'">
                      <div class="row ">
                        <div class="col-md-6">
                          <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">Basic Info</h5>
                          </div>
                          <div class="">
                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" style="font-weight: 300;">ID Employee</label>
                              <input type="text" class="form-control" v-model="currentEmployee.employee_id2" :disabled="isReadOnly" placeholder="" />
                              
                              
                            </div>
                            
                            <div class="d-flex align-items-center mb-2 form-group">
                              <label for="" class="col-3" >Type of Attendance <span class="text-danger">*</span></label>
                              <vue-select :options="AttendanceList" v-model="currentEmployee.jenis_absensi" :disabled="isReadOnly" class="w-100" placeholder="None" required/>
                              
                            </div>

                            
                            
                            
                            <div class="d-flex align-items-center mb-2 form-group">
                              <label for="" class="col-3" >Join Date <span class="text-danger">*</span></label>
                              <div class="input-groupicon w-100" style="z-index: 100;">
                                <datepicker v-model="currentEmployee.join_date" class="picker" :disabled="isReadOnly" :editable="true" :clearable="false"
                                  required />
                                <a class="addonset">
                                  <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                                </a>
                              </div>
                              
                            </div>

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >Branch <span class="text-danger">*</span></label>
                              <!-- <input type="text" v-model="currentEmployee.lokasi_id" class="form-control" placeholder=""> -->
                              <vue-select :options="LocationList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.lokasi_id" placeholder="None" class="w-100" :disabled="isReadOnly" required>
                              </vue-select>
                            </div>

                            <div class="d-flex align-items-center mb-3 form-group">
                              <label for="" class="col-3" >Departement</label>
                              <vue-select :options="DepartementList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.departemen_id" placeholder="None" :disabled="isReadOnly" class="w-100">
                              </vue-select>

                            </div>
                            <div class="d-flex align-items-center mb-3">
                              <label for="" class="col-3" >Job Title</label>
                              <model-select :options="JobTitleList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.jabatan_id" class="w-100" placeholder="None" style="z-index: 999;"></model-select>
                              <!-- <vue-select  :options="JobTitleList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.jabatan_id" class="w-100" :disabled="isReadOnly" placeholder="None">
                              </vue-select> -->
                              
                              
                            </div>
                            <div class="d-flex align-items-center mb-3">
                              <label for="" class="col-3" >Job Level</label>
                              <vue-select  :options="JobLevelList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.job_level" class="w-100" :disabled="isReadOnly" placeholder="None">
                              </vue-select>
                              
                              
                            </div>

                            <div class="d-flex align-items-center mb-3">
                              <label for="" class="col-3" >Job Grade <span class="text-danger">*</span></label>
                              <vue-select  :options="GolonganList" :settings="{ settingOption: value, settingOption: value }"
                                  v-model="currentEmployee.golongan" class="w-100" :disabled="isReadOnly" placeholder="None">
                              </vue-select>
                            
                            
                            </div>

                            <div class="d-flex align-items-center mb-3">
                              <label for="" class="col-3" >Shift</label>
                              <vue-select :options="ShiftList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.shift_id" class="w-100" :disabled="isReadOnly" placeholder="None">
                              </vue-select>
                              
                              
                            </div>

                          </div>

                        </div>


                        <div class="col-md-6">
                          <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">Approval Line</h5>
                          </div>

                          <div class="">

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >Direct Suprevisor</label>
                              <vue-select :options="employeeList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.atasan_langsung" class="w-100" :disabled="isReadOnly" placeholder="None">
                              </vue-select>
                            </div>

                            <div class="d-flex align-items-center mb-3">
                              <label for="" class="col-3" >Indirect Suprvisor</label>
                              <vue-select :options="employeeList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.atasan_tidak_langsung" :disabled="isReadOnly" class="w-100" placeholder="None">
                              </vue-select>
                              
                            </div>

                          
                            
                          </div>

                          <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">Status</h5>
                          </div>

                          <div class="">

                            <div class="d-flex align-items-center mb-2 form-group">
                              <label for="" class="col-3" >Employee Status <span class="text-danger">*</span></label>
                              <vue-select :options="employeeStatusList" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.status_karyawan" :disabled="isReadOnly" class="w-100" placeholder="None" required>
                              </vue-select>
                              
                              
                            </div>

                            <div class="d-flex align-items-center mb-2 form-group" v-if="currentEmployee.status_karyawan !== 'PERMANENT'">
                              <label for="" class="col-3" >Start Date</label>
                              <div class="input-groupicon w-100" style="z-index: 100;">
                                <datepicker v-model="currentEmployee.tanggal_mulai_kontrak" :disabled="isReadOnly" class="picker" :editable="true" :clearable="false"
                                  required />
                                <a class="addonset">
                                  <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                                </a>
                              </div>
                            
                            </div>

                            <div class="d-flex align-items-center mb-2 form-group"  v-if="currentEmployee.status_karyawan !== 'PERMANENT'">
                              <label for="" class="col-3" >End Date</label>
                              <div class="input-groupicon w-100" style="z-index: 99;">
                                <datepicker v-model="currentEmployee.tanggal_berakhir_kontrak" :disabled="isReadOnly" class="picker" :editable="true" :clearable="false"
                                  required />
                                <a class="addonset">
                                  <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                                </a>
                              </div>
                            
                            </div>

                            <div class="d-flex align-items-center mb-2 form-group">
                              <label for="" class="col-3" >Balance Leave</label>
                              <input type="number" v-model="currentEmployee.saldo_cuti" :disabled="isReadOnly" placeholder="">
                              
                              
                            </div>

                            

                          </div>

                          <div class="title-tab py-2 mb-3" >
                              <h5 class="fw-bold">Bank Account</h5>
                          </div>

                          <div class="">

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >Bank Name</label>
                              <model-select :options="bankList" :isDisabled="isReadOnly" :settings="{ settingOption: value, settingOption: value }"
                                v-model="currentEmployee.nama_bank" class="w-100" placeholder="None"></model-select>
                            
                              <!-- :settings="{ settingOption: value, settingOption: value }" -->
                              <!-- <input type="text" name="nama_bank" class="form-control" v-model="currentEmployee.nama_bank" /> -->
                            </div>

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >Account Number</label>
                              <div class="col d-flex align-items-center gap-2 px-0">
                                <input type="text" class="form-control" :class="{ 'is-invalid': rekeningNotFound }" :disabled="isReadOnly" v-model="currentEmployee.nomor_rekening" />
                                <button  :class="(!currentEmployee.nama_bank || isChecking) ? 'btn btn-secondary' : 'btn btn-outline-primary'" type="button" @click="cekNoRek" :disabled="isChecking || !currentEmployee.nama_bank"
                                style="font-size: 12px; padding: 4px 10px;">
                                  
                                  {{ isChecking ? ` (${checkCountdown}s)` : 'Validate' }}
                                  <!-- {{ isChecking ? 'Checking...' : 'Check' }} -->
                                </button>
                                <!-- <input type="text" name="nomor_rekening" class="form-control" v-model="currentEmployee.nomor_rekening" /> -->
                              </div>
                            
                            </div>

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3">Account Holder's Name</label>
                              <input type="text" name="nama_rekening" class="form-control" v-model="currentEmployee.nama_rekening" disabled/>
                              
                            </div>

                        
                            
                          </div>


                        </div>
                      </div>
                      
                    </div>
                  </div>

                  <div class="row" :class="{ 'custom-active': active_page !== 'salary' }" v-show="tipe_user === 'OWNER'">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'salary'">
                      <div class="row ">
                        <div class="title-tab py-2 mb-3" >
                          <h5 class="fw-bold">Salary Detail</h5>
                        </div>
                        <div class="">
                          <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                              <label>Salary <span class="text-danger">*</span></label>
                              <div class="d-flex gap-1">
                                <input type="text" :disabled="isReadOnly" v-model="currentEmployee.salary[0].nilai" style="width: 55%;"
                                  @input="formatCurrency(currentEmployee.salary[0].nilai, 0)" required />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[0].metode" placeholder="None"
                                  class="flex-fill" :disabled="isReadOnly" />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                              <label>Fixed Allowance</label>
                              <div class="d-flex gap-1">
                                <input type="text" :disabled="isReadOnly" v-model="currentEmployee.salary[1].nilai" style="width: 55%;"
                                  :ref="currentEmployee.salary[1].id"
                                  @input="formatCurrency(currentEmployee.salary[1].nilai, 1)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[1].metode" placeholder="None"
                                  class="flex-fill" :disabled="isReadOnly" />
                              </div>

                            </div>
                          </div>
                          <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                              <label>Attendance Allowance</label>
                              <div class="d-flex gap-1">
                                <input type="text" :disabled="isReadOnly" v-model="currentEmployee.salary[2].nilai" style="width: 55%;"
                                  :ref="currentEmployee.salary[2].id"
                                  @input="formatCurrency(currentEmployee.salary[2].nilai, 2)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[2].metode" placeholder="None"
                                  class="flex-fill" :disabled="isReadOnly" />
                              </div>

                            </div>
                          </div>
                          <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                              <label>Meal Allowance</label>
                              <div class="d-flex gap-1">
                                <input type="text" :disabled="isReadOnly" v-model="currentEmployee.salary[3].nilai" style="width: 55%;"
                                  :ref="currentEmployee.salary[3].id"
                                  @input="formatCurrency(currentEmployee.salary[3].nilai, 3)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[3].metode" placeholder="None"
                                  class="flex-fill" :disabled="isReadOnly" />
                              </div>

                            </div>
                          </div>
                          <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                              <label>Transport Allowance</label>
                              <div class="d-flex gap-1">
                                <input type="text" :disabled="isReadOnly" v-model="currentEmployee.salary[4].nilai" style="width: 55%;"
                                  :ref="currentEmployee.salary[4].id"
                                  @input="formatCurrency(currentEmployee.salary[4].nilai, 4)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[4].metode" placeholder="None"
                                  class="flex-fill" :disabled="isReadOnly" />
                              </div>

                            </div>
                          </div>
                          <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                              <label>Non-fixed Allowance</label>
                              <div class="d-flex gap-1">
                                <input type="text" :disabled="isReadOnly" v-model="currentEmployee.salary[5].nilai" style="width: 55%;"
                                  :ref="currentEmployee.salary[5].id"
                                  @input="formatCurrency(currentEmployee.salary[5].nilai, 5)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[5].metode" placeholder="None"
                                  class="flex-fill" :disabled="isReadOnly" />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                              <label>Other Allowances</label>
                              <div class="d-flex gap-1">
                                <input type="text" :disabled="isReadOnly" v-model="currentEmployee.salary[6].nilai" style="width: 55%;"
                                  :ref="currentEmployee.salary[6].id"
                                  @input="formatCurrency(currentEmployee.salary[6].nilai, 6)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[6].metode" placeholder="None"
                                  class="flex-fill" :disabled="isReadOnly" />
                              </div>

                            </div>
                          </div>
                          <div class="col-lg-12 col-sm-12 col-12">
                            <div class="form-group">
                              <label>Other Allowances 2</label>
                              <div class="d-flex gap-1">
                                <input type="text" :disabled="isReadOnly" v-model="currentEmployee.salary[7].nilai" style="width: 55%;"
                                  :ref="currentEmployee.salary[7].id"
                                  @input="formatCurrency(currentEmployee.salary[7].nilai, 7)" />
                                <vue-select :options="TipeKerjaList" v-model="currentEmployee.salary[7].metode" placeholder="None"
                                  class="flex-fill" :disabled="isReadOnly" />
                              </div>
                            </div>
                          </div>


                        </div>
                        <!-- <div class="col-md-6">

                        </div> -->

                        

                        
                      </div>
                      
                    </div>
                  </div>

                  <div class="row" :class="{ 'custom-active': active_page !== 'tax_config' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'tax_config'">
                      <div class="row ">
                        <div class="col-12">
                          
                          <div class="">
                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" style="font-weight: 300;">NPWP</label>
                              <input type="text" :disabled="isReadOnly" class="form-control" v-model="currentEmployee.nomor_npwp" placeholder="">
                              
                              
                              
                              
                            </div>

                            <div class="d-flex align-items-center mb-2 form-group">
                              <label for="" class="col-3" >PTKP Status</label>
                              <vue-select :options="StatusPajakList" :settings="{ settingOption: value, settingOption: value }"
                              v-model="currentEmployee.status_pajak" class="w-100" placeholder="None" :disabled="isReadOnly" />
                            </div>
                            
                            
                            
                            
                            


                          </div>

                        </div>


                        
                      </div>
                      
                    </div>
                  </div>

                  <div class="row" :class="{ 'custom-active': active_page !== 'bpjs_config' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'bpjs_config'">
                      <div class="row ">
                        <div class="col-md-6">
                          <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">BPJS Kesehatan</h5>
                          </div>

                          <div class="">
                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >No. BPJS Kesehatan</label>
                              <input type="text" class="form-control" :disabled="isReadOnly" v-model="currentEmployee.nomor_bpjs_kesehatan" placeholder="" />
                              
                              
                              
                              
                            </div>

                            <div class="d-flex align-items-center mb-2">
                              <label for="" class="col-3" >IDR BPJS Kesehatan</label>
                              <input type="text" class="form-control" :disabled="isReadOnly" v-model="currentEmployee.nominal_bpjs_kesehatan"  @input="formatCurrencyBpjs('nominal_bpjs_kesehatan', currentEmployee.nominal_bpjs_kesehatan)" placeholder="Rp.0,-" />
                              
                              
                              
                              
                            </div>
                        

                          </div>

                        </div>


                        <div class="col-md-6">

                          <div class="title-tab py-2 mb-3" >
                            <h5 class="fw-bold">BPJS Tenaga Kerja</h5>
                          </div>

                          <div class="">

                            <div class="d-flex align-items-center mb-3">
                              <label for="" class="col-3" >No. BPJS TK</label>
                              <input type="text" class="form-control" :disabled="isReadOnly" v-model="currentEmployee.nomor_bpjs_tk" placeholder=""/>
                            </div>
                            <div class="d-flex align-items-center mb-3">
                              <label for="" class="col-3" >IDR BPJS TK</label>
                              <input type="text" class="form-control" :disabled="isReadOnly" v-model="currentEmployee.nominal_bpjs_tk" @input="formatCurrencyBpjs('nominal_bpjs_tk', currentEmployee.nominal_bpjs_tk)" placeholder="Rp.0,-"/>
                            </div>

                            

                          
                            
                          </div>

                        </div>
                      </div>
                      
                    </div>
                  </div>

                  <div class="row" :class="{ 'custom-active': active_page !== 'history' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'history'">
                      <div class="row ">
                        <div class="col-12">
                          

                          <div class="">
                            <div class="d-flex align-items-center mb-2">
                            
                              <textarea class="form-control" rows="5" :disabled="isReadOnly" v-model="currentEmployee.mutasi_reason" disabled>
                              </textarea>
                              
                              
                              
                              
                            </div>

                            
                        

                          </div>

                        </div>


                        
                      </div>
                      
                    </div>
                  </div>



                  

                </div>

              

              </div>
                <!-- /add -->

              <div class="col-lg-12" >
                
                <div class="d-flex align-items-center gap-2 ms-auto">
                  <button  v-if="currentEmployee.terminate_date === ''" type="submit" class="btn btn-submit">Save</button>
                  <router-link to="employee" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>
              
                
            </form>

          </div>
        </div>
         
        
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import { ShowLoading, CloseLoading, ErrorConnectionTimeOut, base_url, AlertPopup, AlertPopup2, goPage, formatCurrency, rupiah, rupiahoutput, rupiahInput, AlertBottom, sanitizeForMySQL, appendForm, timeout } from "@/assets/js/function";
import { RouterLink } from "vue-router";
import { ModelSelect } from "vue-search-select";


import { VueTelInput } from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'

export default {
  name: "editemployee",
  components: {
    // Form,
    // Field,
    ModelSelect,
    VueTelInput,
  },
  data() {
    return {
      filter: true,
      title: "Detail Employee",
      title1: "Manage Employee",
      namaCompany: "",
      config: "",
      api: "",
      foto_ktp_img: "",

      // select option
      TipeKerjaList: ["MONTH", "DAILY"],
      ShiftList: [],
      LocationList: [],
      AttendanceList: ["SCANQR", "SELFIE", "FINGERPRINT"],
      GenderList: ["MALE", "FEMALE"],
      ReligionList: ["ISLAM", "KRISTEN PROTESTAN", "KRISTEN KATOLIK", "HINDU", "BUDDHA", "KONGHUCU"],
      DepartementList: [],
      JobTitleList: [],
      employeeList: [],
      GolonganList: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      StatusPajakList: [],
      JobLevelList: ["DIREKTUR", "MANAGER", "SUPERVISOR", "STAFF"],
      employeeStatusList: ["PERMANENT", "CONTRACT", "PROBATION", "INTERNSHIP"],
      maritalStatusList: ['BELUM KAWIN','KAWIN','CERAI HIDUP','CERAI MATI'],
      bloodTypeList: [ 'A', 'B', 'AB', 'O'],

      //data
      currentEmployee: [
        {
          foto_ktp: "",
          telepon: "",
          kontak_darurat: "",
        }
      ],
      currentDate: new Date,


      Computers: ["Computers", "Mac"],
      None: ["None", "option1"],
      Tax: ["Choose Tax", "2%"],
      Percentage: ["Percentage", "10%", "20%"],
      Piece: ["Piece", "Kg"],
      Active: ["Active", "Open"],

      // for edit button to change the text to form input
      isEditing: false,

      // for bank list 
      bankList: [],
      isChecking: false,
      checkCountdown: 0, // seconds left
      countdownInterval: null, // interval ID
      rekeningNotFound: false,
      hasCheckedRekening: false,

      active_page: "general_info",
      isActive: true,
      tipe_user: '',
      actionState: '',
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }
    this.tipe_user = localStorage.getItem('tipe_user');
    localStorage.setItem('actionState', 'update')
    this.namaCompany = localStorage.getItem('namaCompany');
    
    

    // load daftar bank
    // this.daftarBank();

    //load employee data
    this.currentEmployee = JSON.parse(localStorage.getItem('currentEmployee'));
    
    delete this.currentEmployee.company_id;
    localStorage.setItem('currentEmployee', JSON.stringify(this.currentEmployee));
    
    

    this.currentEmployee.mutasi_reason = this.replaceHashWithBR(this.currentEmployee.mutasi_reason);
    // translate to english  and set tipe_kerja
    if (this.currentEmployee.tipe_kerja == 'HARIAN') {
      this.currentEmployee.tipe_kerja = 'DAILY'
    } else {
      this.currentEmployee.tipe_kerja = 'MONTH'
    }

    const bankList = JSON.parse(localStorage.getItem('bankList'));
    bankList.forEach((value, index) => {
      const element = { value: value.bank_code, text: value.name }
      this.bankList.push(element);
    });

    //load shift list

    const shift = JSON.parse(localStorage.getItem('shiftList'));
    this.ShiftList.push({ id: 0, text: "None" })
    shift.forEach((value, index) => {
      const element = { id: value.id, text: value.nama_shift + " (" + value.jam_masuk + "-" + value.jam_pulang + ")" }
      this.ShiftList.push(element);
    });

    //load location
    const location = JSON.parse(localStorage.getItem('dataBranchList'));
    location.forEach((value, index) => {
      const element = { id: value.id, text: value.nama_lokasi }
      this.LocationList.push(element);
    });
    //set location
    if (this.currentEmployee.lokasi_id == 0) {
      this.currentEmployee.lokasi_id = location[0].id;
    }

    if (this.currentEmployee.telepon) {
      // if backend stored raw digits without '+'
      if (!this.currentEmployee.telepon.startsWith('+')) {
        this.currentEmployee.telepon = '+' + this.currentEmployee.telepon;
      }
    }

    if (this.currentEmployee.kontak_darurat) {
      // if backend stored raw digits without '+'
      if (!this.currentEmployee.kontak_darurat.startsWith('+')) {
        this.currentEmployee.kontak_darurat = '+' + this.currentEmployee.kontak_darurat;
      }
    }

    //set date of birth
    this.currentEmployee.dob = new Date(this.currentEmployee.dob);

    //set join date 
    if (this.currentEmployee.join_date != "") {
      this.currentEmployee.join_date = new Date(this.currentEmployee.join_date);
    }

    //set start date of contract
    this.currentEmployee.tanggal_mulai_kontrak = new Date(this.currentEmployee.tanggal_mulai_kontrak);

    //set end date of contract
    this.currentEmployee.tanggal_berakhir_kontrak = new Date(this.currentEmployee.tanggal_berakhir_kontrak);

    // set gender
    if (this.currentEmployee.jenis_kelamin == "PRIA") {
      this.currentEmployee.jenis_kelamin = 'MALE';
    } else if (this.currentEmployee.jenis_kelamin == "WANITA") {
      this.currentEmployee.jenis_kelamin = 'FEMALE';
    }

    //set departement
    const departement = JSON.parse(localStorage.getItem('departemenList'));
    departement.forEach((value, index) => {
      const element = { id: value.id, text: value.nama_departemen }
      this.DepartementList.push(element);
    });

    //set jabatan
    const jabatan = JSON.parse(localStorage.getItem('jabatanList'));
    jabatan.forEach((item, index) => {
      // const element = { id: value.id, text: value.nama_jabatan }
      const element = { value: item.id, text: item.nama_jabatan }
      this.JobTitleList.push(element);
    });

    //set employee
    const employee = JSON.parse(localStorage.getItem('employeeList'));
    employee.forEach((value, index) => {
      const element = { id: value.id, text: value.nama }
      this.employeeList.push(element);
    });
    // Add the hardcoded "None" option at the top of the list
    this.employeeList.unshift({ id: 'null', text: 'None' });
    // this.employeeList.push({ id: 'null', text: "None" });

    //set pajak 
    const pajak = JSON.parse(localStorage.getItem('statusPajakList'));
    pajak.forEach((value, index) => {
      const element = { id: value.status, text: value.status }
      this.StatusPajakList.push(element);
    });

    //set salary  to english

    this.currentEmployee.salary.forEach((value, index) => {
      this.currentEmployee.salary[index].nilai = rupiah(this.currentEmployee.salary[index].nilai);
      if (value.metode === 'BULANAN') {
        this.currentEmployee.salary[index].metode = 'MONTH';
      } else {
        this.currentEmployee.salary[index].metode = 'DAILY';
      }
    });

    this.currentEmployee.nominal_bpjs_kesehatan = rupiahInput(Math.floor(this.currentEmployee.nominal_bpjs_kesehatan));
    this.currentEmployee.nominal_bpjs_tk = rupiahInput(Math.floor(this.currentEmployee.nominal_bpjs_tk));

    

  },

  computed: {
    isReadOnly() {
      return this.currentEmployee?.terminate_date !== '';
    }
  },

  methods: {
    rupiah, rupiahoutput,

    onPhoneChange(number, phoneObject, input) {
      if (phoneObject?.formatted) {
        this.currentEmployee.telepon = phoneObject.formatted;
       
      }

    },

    onPhoneEmergencyChange(number, phoneObject, input) {
      if (phoneObject?.formatted) {
        this.currentEmployee.kontak_darurat = phoneObject.formatted;
       
      }

    },



    activePage(page) {
      this.active_page = page;
      localStorage.setItem("active_page", page)
    },

    replaceHashWithBR(inputString) {
      return inputString.replace(/#/g, '\n');
    },
    formatCurrency(number, index) {
      this.currentEmployee.salary[index].nilai = rupiahInput(number);
    },
    // for bpjs form input 
    formatCurrencyBpjs(name) {
      this.currentEmployee[name] = rupiahInput(this.currentEmployee[name]);
    },

     // for image foto_ktp upload
    triggerUpload() {
      this.$refs.foto_ktp.click();
    },

    handleUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.currentEmployee.foto_ktp = e.target.result; // base64
        };
        reader.readAsDataURL(file);
      }
    },

     // check bank account number to api
    async cekNoRek() {
      if (this.isChecking) return; // Prevent double click
      this.isChecking = true;

      const formData = new FormData();
      
      this.startCountdown(20); // Optional UI feature


      formData.append("token", 'd2afa5fa-c31c-4bf8-932b-c565c14ba1f1');
      formData.append("bank_code", this.currentEmployee.nama_bank);
      formData.append("account_number", this.currentEmployee.nomor_rekening);

      

      if (!this.currentEmployee.nomor_rekening || !this.currentEmployee.nama_bank) {
        
        AlertPopup2("error", "", "Please select a bank and enter account number.", false, 1500);
        this.isChecking = false;
        clearInterval(this.countdownInterval);
        return;
      }

      for (let [key, value] of formData.entries()) {
          console.log(key, value);
      }
      // return


      const api = base_url + '/v3/flip/inquiry_rekening';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;

      console.log('ini data cek no rek', data)
      if(data.status){

        // if (!data.ok) {
        //   // Custom handling for 404
        //   if (response.status === 404) {
        //       this.rekeningNotFound = true; // show red border
        //     throw new Error("Bank account not found");
        //   }
        //   throw new Error("HTTP error " + response.status);
        // }
        if(data.data.status == 'SUCCESS') {

          this.currentEmployee.nama_rekening = data.data.account_holder;
          this.rekeningNotFound = false;
          this.hasCheckedRekening = true;
          
          AlertBottom("Data found: " + data.data.account_holder);
          
        }else {
          this.currentEmployee.nama_rekening = '';
          this.rekeningNotFound = true;
          this.hasCheckedRekening = true; // <-- checked but not found
          
          AlertPopup2("error", "", data.message, true, 1500);

        }
        


        
      }else {
          // AlertPopup2("error", "", data.message, true, 1500);
        
          if (data.message === "Bank account not found") {
            this.rekeningNotFound = true;
            this.hasCheckedRekening = true; // <-- checked but not found
            AlertPopup2("error", "", data.message, true, 1500);

          

          } else {
            AlertPopup2("error", "", data.message, true, 1500);
          }
      }

      
    },


    startCountdown(seconds) {
      this.checkCountdown = seconds;

      this.countdownInterval = setInterval(() => {
        this.checkCountdown--;

        if (this.checkCountdown <= 0) {
          clearInterval(this.countdownInterval);
          this.isChecking = false;
        }
      }, 1000);
    },


    daftarBank() {
      ShowLoading();
      

        const url = 'https://cekrekening-api.belibayar.online/api/v1/bank-list';

        fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'User-Agent': navigator.userAgent
          }
        })
      // axios
        // .post(this.api, '', this.config)
        .then(response => response.json())
        .then((result) => {
          console.log('ini hasil dari api bank',result)
          if (result.success == true) {
            // AlertBottom(response.data.message);

            this.bankList = [];

            // response.data.data.forEach((item, index) => {


            //     response.data.data.forEach((item, index) => {
            //         let item_prepare = { ...item, no: (index + 1), };
            //         this.data.push(item_prepare);
            //     });
            //     this.bankList.push(item_prepare);
            // });

            const banks = result.data.banks.map((item, index) => ({
              text: item.label ?? '', // the display text
              value: item.value ?? '' // use item.code or item.name depending on your need
            }));

            const ewallets = result.data.ewallets.map((item) => ({
              text: item.label ?? '',
              value: item.value ?? ''
            }));

            this.bankList = [{ text: 'None', value: '' }, ...banks, ...ewallets]; 

            console.log('ini daftar bank semua:', this.bankList)
            
            CloseLoading();
          }
          if (result.success == false) {
            AlertPopup("error", "", result.data.message, 1500, false);
          }
        })
        .catch((error) => {
          ErrorConnectionTimeOut(error);
        });


    },

    formatDate(dob) {
    if (!dob) return '';
    const date = new Date(dob);
    if (isNaN(date)) return '';

    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options); // "25 Feb 2025"
  },

    calculateAge(dob) {
      if (!dob) return '';
      const birthDate = new Date(dob);
      if (isNaN(birthDate)) return '';
      
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return `${age} Years Old`;
    },

    getNameFileUrl(url) {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return fileName;
    },
    formatDate(dateInput) {
      const dateObj = new Date(dateInput);
      if (isNaN(dateObj.getTime())) return null; // Invalid date check

      const year = dateObj.getFullYear();
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      const day = ('0' + dateObj.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },

    async update() {
      const formData = new FormData();
      appendForm(formData)

      Object.entries(this.currentEmployee).forEach(([key, value]) => {
        formData.append(key, sanitizeForMySQL(value));
      });

      const teleponClean = this.currentEmployee.telepon.slice(1).replace(/\s+/g, "")
      formData.set("telepon", teleponClean);

      const kontakEmergencyClean = this.currentEmployee.kontak_darurat.slice(1).replace(/\s+/g, "")
      formData.set("kontak_darurat", kontakEmergencyClean);

      formData.delete("tipe_kerja");
      if (this.currentEmployee.tipe_kerja == 'DAILY') {
        formData.append("tipe_kerja", "HARIAN");
      } else {
        formData.append("tipe_kerja", "BULANAN");
      }

      //set to jenis_kelamin to indonesia to save
      formData.delete("jenis_kelamin");
      if (this.currentEmployee.jenis_kelamin == 'MALE') {
        formData.append("jenis_kelamin", "PRIA");
      } else {
        formData.append("jenis_kelamin", "WANITA");
      }
      formData.delete("salary");

      //set salary back to indonesia to save
      formData.append("jenis", "gaji#tunjangan_tetap#tunjangan_kehadiran#tunjangan_makan#tunjangan_transport#tunjangan_tidak_tetap#tunjangan_lain#tunjangan_lain2");

      // set salary
      let metode = "";
      let nilai = "";
      this.currentEmployee.salary.forEach((value, index) => {
        if (index != 7) {
          if (this.currentEmployee.salary[index].metode == "MONTH") {
            metode = metode + "BULANAN#"
          } else {
            metode = metode + "HARIAN#"
          }
          nilai = nilai + rupiahoutput(this.currentEmployee.salary[index].nilai) + "#"
        } else {
          if (this.currentEmployee.salary[index].metode == "MONTH") {
            metode = metode + "BULANAN"
          } else {
            metode = metode + "HARIAN"
          }
          nilai = nilai + rupiahoutput(this.currentEmployee.salary[index].nilai)
        }
      });
      formData.append("metode", metode);
      formData.append("nilai", nilai);

      //set dob
      formData.delete("dob");
      const dobDate = this.formatDate(this.currentEmployee.dob);
      if (dobDate) {
        formData.append("dob", dobDate);
      }

      //set join date
      formData.delete("join_date");
      const joinDate = this.formatDate(this.currentEmployee.join_date);
      if (joinDate) {
        formData.append("join_date", joinDate);
      }

      //set start date & end date contract
      formData.delete("tanggal_mulai_kontrak");
      const tanggalKontrak = this.formatDate(this.currentEmployee.tanggal_mulai_kontrak);
      if (tanggalKontrak) {
        formData.append("tanggal_mulai_kontrak", tanggalKontrak);
      }

      formData.delete("tanggal_berakhir_kontrak");
      const tanggalEndKontrak = this.formatDate(this.currentEmployee.tanggal_berakhir_kontrak);
      if (tanggalEndKontrak) {
        formData.append("tanggal_berakhir_kontrak", tanggalEndKontrak);
      }

      // for status_karyawan
      formData.delete("status_karyawan");
      formData.append("status_karyawan", this.currentEmployee.status_karyawan);

      formData.delete("nominal_bpjs_tk");
      formData.append("nominal_bpjs_tk", rupiahoutput(this.currentEmployee.nominal_bpjs_tk));

      formData.delete("nominal_bpjs_kesehatan");
      formData.append("nominal_bpjs_kesehatan", rupiahoutput(this.currentEmployee.nominal_bpjs_kesehatan));


      //set image
      formData.delete("foto_ktp");
      formData.delete("foto_bukurekening");
      formData.delete("foto_kartukeluarga");

      if (this.$refs.foto_ktp.value != "") {
        formData.append("foto_ktp", this.$refs.foto_ktp.files[0]);
      }
      // if (this.$refs.foto_bukurekening.value != "") {
      //   formData.append("foto_bukurekening", this.$refs.foto_bukurekening.files[0]);
      // }
      // if (this.$refs.foto_kartukeluarga.value != "") {
      //   formData.append("foto_kartukeluarga", this.$refs.foto_kartukeluarga.files[0]);
      // }

      if ( !this.currentEmployee.job_level || this.currentEmployee.job_level === "" ) {
        AlertPopup('error', '', 'Job Level wajib dipilih!', 1500, false);
        return
      } else if( !this.currentEmployee.status_karyawan || this.currentEmployee.status_karyawan === "" ) {
        AlertPopup('error', '', 'Employee Status wajib dipilih!', 1500, false);
        return
      }else if (this.currentEmployee.nomor_rekening && this.currentEmployee.nomor_rekening.trim() !== "") {
        if (!this.currentEmployee.nama_rekening || this.currentEmployee.nama_rekening.trim() === "") {
          AlertPopup2('error', '', 'Silahkan cek Rekening terlebih dahulu!', true, 1500);
          return;
        }
        // else if (this.rekeningNotFound) {
        //   AlertPopup("error", "", "Nomor rekening harus valid dan terdaftar!", 1500, false);
        //   return;
        // }else if (!this.hasCheckedRekening) {
        //   AlertPopup("error", "", "Silakan cek nomor rekening terlebih dahulu!", 1500, false);
        //   return;
        // }

      }
      // else if (!this.hasCheckedRekening) {
      //   AlertPopup("error", "", "Silakan cek nomor rekening terlebih dahulu!", 1500, false);
      //   return;
      // }


      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }
      // return true

      const api = base_url + '/v3/employees/update';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;
      if (data.status) {
          AlertBottom(data.message);
          goPage("employee");

          
      } else {
          AlertPopup2("error", "", data.message, true, 1500);
      }


    },
  },

};
</script>

<style scoped>
  /* for select phone number country code */
  ::v-deep .vti__dropdown-list {
    z-index: 999 !important; /* higher than Bootstrap modal default */
  }
  ::v-deep .vti__dropdown-list.below {
    z-index: 999 !important; /* higher than Bootstrap modal default */
  }
  
  .upload-box {
    border: 2px dashed #ccc;
    border-radius: 8px;
    background-color: #f9f9f9;
    width: 200px;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    margin-left: 1rem;
  }

  .upload-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
  }

  .image-edit-container {
    position: relative;
    display: inline-block;
    cursor: pointer;
  }

  .image-edit-container img {
    transition: 0.3s ease;
  }

  .image-edit-container .edit-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    font-size: 2rem;
    color: white;
    pointer-events: none;
    transition: 0.3s ease;
  }

  .image-edit-container:hover img {
    filter: blur(2px) brightness(0.7);
  }

  .image-edit-container:hover .edit-icon {
    opacity: 1;
  }


  /* for menu tab */

  .menu-top {
    background-color: #09B67D33; /* Adjust opacity and color as needed */
    /* border-bottom: 4px solid #073C69; Primary color (Bootstrap default) */
    color: #09B67D; /* Dark text color (Bootstrap default) */
    font-weight: 500;
    border-radius: 5px 5px 0 0;
  }

  .responsive-detail {
    max-height: 100vh; /* Or any height you want */
    overflow-y: auto;

    /* Hide scrollbar for WebKit browsers */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE 10+ */
  }

  .responsive-detail::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  /* for class invalid no rek */
  .is-invalid {
    border-color: red;
    color: red;
  }
</style>